import React from 'react';

export default class temperature extends React.Component {
  constructor(props) {
    super(props);

    let currentTemp = '';
    let time = new Date();
    let hours = time.getHours();
    let month = time.getMonth();
    let conditionArray = ['cloudy'];

    if (month < 3 || month > 9) {
      currentTemp = '29';
      conditionArray.push('snow');
    } else {
      currentTemp = '62';
      conditionArray.push('rain');
    }

    if (hours > 4 && hours < 19) {
      conditionArray.push('clearDay');
      conditionArray.push('partlyCloudy');
    } else {
      conditionArray.push('clearNight');
      conditionArray.push('partlyCloudyNight');
    }

    let cond = Math.floor(Math.random() * conditionArray.length);

    this.state = {
      temp: currentTemp,
      conditions: conditionArray[cond]
    };
  }

  render() {
    return (
      <div className="temperature">
        <div className="temp">
          {this.state.temp}&#176;F
          <img className={this.state.conditions} alt="" />
        </div>
      </div>
    );
  }
}
